<mat-card appearance="outlined">
  <mat-card-content class="header-container">
    <div class="link-title">
      <button class="title-button" mat-button [matMenuTriggerFor]="links">
        <span class="title-text">{{ selectedLink?.displayUrl }}</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #links="matMenu">
        <div *ngFor="let link of allLinks">
          <button mat-menu-item (click)="changeLink(link.url)">
            <span class="dropdown-text">{{ link.displayUrl }}</span>
          </button>
        </div>
      </mat-menu>
    </div>
    <div class="link-stat">
      <div class="stat-title">{{ 'EMAIL_STATS.CLICK_RATIO' | translate }}</div>
      <ng-container *ngIf="selectedLink && (loading$ | async) === false; else loadingStat">
        <div class="stat-num">{{ selectedLink.displayClickRate }}</div>
      </ng-container>
    </div>
    <div class="link-stat">
      <div class="stat-title">{{ 'EMAIL_STATS.TOTAL_CLICKS' | translate }}</div>
      <ng-container *ngIf="selectedLink && (loading$ | async) === false; else loadingStat">
        <div class="stat-num">{{ selectedLink.totalClicks ? selectedLink.totalClicks : 0 }}</div>
      </ng-container>
    </div>
    <div class="link-stat">
      <div class="stat-title">{{ 'EMAIL_STATS.UNIQUE_CLICKS' | translate }}</div>
      <ng-container *ngIf="selectedLink && (loading$ | async) === false; else loadingStat">
        <div class="stat-num">{{ selectedLink.uniqueClicks ? selectedLink.uniqueClicks : 0 }}</div>
      </ng-container>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #loadingStat>
  <glxy-loading-spinner></glxy-loading-spinner>
</ng-template>
